import { getTvObject, tv } from '@costar-ui/cosmos';
import radiusOptions from '../../../common/radius-options/radius-options.esm.js';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';
import cardCommon from '../common/index.esm.js';

var cardHeaderTV = getTvObject({
  base: ['flex', 'flex-row', 'justify-between', 'items-center', 'w-full', 'flex-nowrap', 'print:pb-0', 'print:px-0'],
  variants: {
    padding: cardCommon.padding,
    radius: radiusOptions.radiusTop,
    gap: spacingOptions.gap,
    withDivider: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    padding: 'xxs',
    withDivider: false,
    className: ['pb-px']
  }, {
    padding: 'xs',
    withDivider: false,
    className: ['pb-0.5']
  }, {
    padding: 'sm',
    withDivider: false,
    className: ['pb-1']
  }, {
    padding: 'md',
    withDivider: false,
    className: ['pb-1.5']
  }, {
    padding: 'lg',
    withDivider: false,
    className: ['pb-2']
  }, {
    padding: 'xl',
    withDivider: false,
    className: ['pb-2.5']
  }, {
    padding: '2xl',
    withDivider: false,
    className: ['pb-3']
  }, {
    padding: '3xl',
    withDivider: false,
    className: ['pb-3.5']
  }]
});
var base = tv(cardHeaderTV);
var cardHeaderStyles = {
  base: base
};

export { cardHeaderStyles, cardHeaderTV };
//# sourceMappingURL=card-header.styles.esm.js.map
